module.exports = __webpack_public_path__ + "static/20141025_110712-ab96ebc81bad13c54170fd2f58ab3b99.jpg";